import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autogrow"
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { 
    minHeight: { type: Number, default: 38 },
    maxHeight: { type: Number, default: 200 },
    threshold: { type: Number, default: 50 },
    submitOnEnter: { type: Boolean, default: true }
  }

  connect() {
    this.resize()
    // Set initial styles
    this.inputTarget.style.overflow = 'hidden'
    this.inputTarget.style.resize = 'none'
    this.inputTarget.style.transition = 'height 0.1s ease'
    this.inputTarget.style.minHeight = `${this.minHeightValue}px`
  }

  resize() {
    const input = this.inputTarget
    const scrollLeft = window.pageXOffset
    const scrollTop = window.pageYOffset
    
    // Temporarily reset height to get accurate scrollHeight measurement
    input.style.height = 'auto'
    
    // Calculate the height needed for the content
    let newHeight = Math.max(input.scrollHeight, this.minHeightValue)
    newHeight = Math.min(newHeight, this.maxHeightValue)
    
    // Apply the calculated height
    input.style.height = `${newHeight}px`
    
    // Restore scroll position to prevent jumping
    window.scrollTo(scrollLeft, scrollTop)
  }

  // Handle input event for auto-resize
  input() {
    this.resize()
  }

  // Handle paste event
  paste() {
    setTimeout(() => this.resize(), 0)
  }

  // Handle form reset
  reset() {
    setTimeout(() => {
      this.inputTarget.style.height = `${this.minHeightValue}px`
    }, 0)
  }
  
  // Handle keyboard events for submit
  keydown(event) {
    if (this.submitOnEnterValue && event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      
      // Find the form and submit it
      const form = this.inputTarget.closest('form')
      if (form) {
        // Find submit button or use form.submit()
        const submitButton = this.hasSubmitTarget ? this.submitTarget : form.querySelector('[type="submit"]')
        if (submitButton) {
          submitButton.click()
        } else {
          form.requestSubmit()
        }
      }
    }
  }
}